import Component from '@glimmer/component';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import EmberTooltip from 'ember-tooltips/components/ember-tooltip';
import { SENSITIVE_FIELD_SHIELD_MESSAGE } from 'garaje/utils/sensitive-field-shield';

interface SensitiveFieldShieldSignature {
  Element: HTMLSpanElement;
}

export default class SensitiveFieldShield extends Component<SensitiveFieldShieldSignature> {
  message = SENSITIVE_FIELD_SHIELD_MESSAGE;

  <template>
    <span
      class="relative inline-flex items-center align-[-0.125em] ml-1 text-carbon-50"
      tabindex="0"
      role="img"
      aria-label={{this.message}}
      data-test-sensitive-shield
      ...attributes
    >
      {{svgJar "sensitive-shield" width="10.5" height="14" aria-hidden="true"}}
      <EmberTooltip @side="top" @delay={{200}} @popperContainer="body" @tooltipClass="!max-w-96">
        {{this.message}}
      </EmberTooltip>
    </span>
  </template>
}
